import { render, staticRenderFns } from "./Theme2Home.vue?vue&type=template&id=a915164a&scoped=true&"
import script from "./Theme2Home.vue?vue&type=script&lang=js&"
export * from "./Theme2Home.vue?vue&type=script&lang=js&"
import style0 from "./Theme2Home.vue?vue&type=style&index=0&id=a915164a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a915164a",
  null
  
)

export default component.exports